import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import { withDefaults } from '../../utils/withDefaults';
const FirstGridItemRoot = styled(Grid)({
  paddingTop: '0px!important'
});
export const FirstGridItem = withDefaults(FirstGridItemRoot, {
  size: {
    xs: 12
  }
});